import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";

import userRoutes from "views/routes/userRoutes";

function UserAuth() {
  const location = useLocation();
  const mainContentRef = React.useRef(null);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
    document.body.classList.add("login-bg-default");
    // Specify how to clean up after this effect:
    return function cleanup() {
      document.body.classList.remove("login-bg-default");
    };
  });
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContentRef.current.scrollTop = 0;
  }, [location]);
  const getRoutes = (userRoutes) => {
    return userRoutes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/uauth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <div className="main-content" ref={mainContentRef}>
        <Switch>
          {getRoutes(userRoutes)}
          <Redirect from="*" to="/uauth/login" />
        </Switch>
      </div>
    </>
  );
}

export default UserAuth;
